import styled from 'styled-components';
import ImageWrapper from '../../../../../../new-components/ImageWrapper';
import { useTranslation } from 'next-i18next';
import { commifyNumber } from '../../../../../../helpers/common';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

interface ProjectCardProps {
  name: string;
  area: string;
  slug: string;
  price: { amount: number; currency: string };
  image: string;
}

const ProjectCard = ({ slug, name, area, price, image }: ProjectCardProps) => {
  const { t } = useTranslation('common');

  const isMobile = useSelector((state: any) => state.app.isMobile);
  const router = useRouter();

  const handleClick = () => {
    router.push(`/compound/${slug}`);
  };

  return (
    <Container onClick={handleClick}>
      <ImageWrapper
        src={image}
        alt={`${name} image`}
        width={isMobile ? 200 : 445}
        height={isMobile ? 113 : 237}
        style={{
          ...(!isMobile && { width: '445px', height: '237px' }),
          borderRadius: '8px'
        }}
        objectFit="cover"
        imageSize={isMobile ? 'low' : 'high'}
        sizes="50vw"
      />

      <div className="project-details">
        <div className="name-details">
          <h3 className="name">{name}</h3>
          <h4 className="area">{area}</h4>
        </div>

        {price?.amount && (
          <div className="price-details">
            <span className="start-price">{t('start_price')}</span>
            <span className="price">{`${commifyNumber(price?.amount)} ${
              price?.currency
            }`}</span>
          </div>
        )}
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-self: self-start;
  gap: 8px;
  cursor: pointer;

  .project-details {
    display: flex;
    flex-direction: column;
    text-align: start;
    gap: 10px;

    .name-details {
      display: flex;
      flex-direction: column;

      .name {
        margin: 0;
        color: #212427;
        font-size: ${props => props.theme.font.sizes.xl};
        font-family: materialMedium;
        text-transform: capitalize;
      }

      .area {
        color: #212427;
        margin: 0;
        font-size: ${props => props.theme.font.sizes.xxs};
        font-family: materialRegular;
        text-transform: capitalize;
      }
      gap: 4px;
    }

    .price-details {
      display: flex;
      flex-direction: column;
      gap: 2px;

      .start-price {
        color: #b6b6b6;
        font-size: 10px;
        font-family: materialMedium;
      }

      .price {
        color: #2c3138;
        font-size: 24px;
        font-family: materialBold;
      }
    }

    @media screen and (max-width: ${props =>
        props.theme.breakPoints.mobile.max}) {
      gap: 8px;

      .name-details {
        .name {
          font-size: ${props => props.theme.font.sizes.m};
          font-family: materialSemiBold;
          text-transform: capitalize;
        }

        .area {
          font-size: 10px;
          font-family: materialRegular;
          text-transform: capitalize;
        }
      }

      .price-details {
        gap: 4px;
        .start-price {
          font-family: materialRegular;
        }

        .price {
          font-size: ${props => props.theme.font.sizes.m};
          font-family: materialSemiBold;
        }
      }
    }
  }
`;

export default ProjectCard;
